import React, { useEffect, useState } from 'react';
import IconSearch from '../../../assets/svg/search-icon-grey.svg';

interface SearchPanelProps {
  searchParams?: URLSearchParams;
  setSearchParams?: any;
}

export const SearchPanel = ({ searchParams: searchParamsProp, setSearchParams: setSearchParamsProp }: SearchPanelProps = {}) => {
  const [text, setText] = useState('');

  const onSearchChange = (ev: any) => {
    setText(ev.target.value);
  };

  useEffect(() => {
    if (!setSearchParamsProp) return;
    let timeoutId: NodeJS.Timeout | number = -1;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      setSearchParamsProp((prev: URLSearchParams) => {
        if (text) prev.set('search', text);
        else prev.delete('search');
        return prev;
      });
    }, 300);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [text]);

  useEffect(() => {
    if (!searchParamsProp) return;
    const searchText = searchParamsProp.get('search');
    setText(searchText || '');
  }, [searchParamsProp]);

  return (
    <div className="w-full sm:w-auto">
      <div className="w-full sm:max-w-[333px] relative">
          <img
            className="absolute top-1/2 transform -translate-x-1/2 -translate-y-1/2 left-5"
            alt="search icon"
            src={IconSearch as any}
          />
          <input
            type="text"
            className="w-full sm:w-[333px] h-[40px] px-[2.25rem] py-0 gap-2 bg-surface-2 text-text-2 placeholder-muted rounded-xl focus:outline-none focus:text-text-1"
            id="search-experts"
            placeholder="Search"
            value={text}
            onChange={onSearchChange}
          />
        </div>
      </div>
  );
};
